import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AI_WALLET_INSUFFICIENT_CODE } from '@/app/common/components/AiInsufficientBalanceModal';
import { getAiWarningMessage } from '@/app/common/validators/aiMessages';

const AI_CHARGE_PATH = '/prorogate-or-upgrade/?wallet=500000';

interface AiModalAccessAlertsProps {
  needsApiKeySetup: boolean;
  canUseAi: boolean;
  showInsufficientBalance?: boolean;
}

const AiModalAccessAlerts = ({
  needsApiKeySetup,
  canUseAi,
  showInsufficientBalance = false
}: AiModalAccessAlertsProps) => {
  if (showInsufficientBalance) {
    return (
      <div className="d-flex flex-1 align-items-center justify-content-center p-3 h-100">
        <Alert variant="warning" className="mb-0 fs--1 w-100">
          <div className="mb-2">
            {getAiWarningMessage(AI_WALLET_INSUFFICIENT_CODE)}
          </div>
          <div className="d-flex justify-content-end">
            <Link to={AI_CHARGE_PATH} className="btn btn-primary btn-sm">
              شارژ افزونه AI
            </Link>
          </div>
        </Alert>
      </div>
    );
  }

  if (needsApiKeySetup) {
    return (
      <Alert variant="warning" className="m-3 mb-0 fs--1">
        شما حالت «کلید API شخصی» را فعال کرده‌اید، اما هنوز کلیدی ثبت نشده است.
        <br />
        برای ادامه، به <Link to="/settings/ai">تنظیمات AI</Link> بروید و یک کلید
        API اضافه کنید.
        <br />
        یا می‌توانید حالت «AI خودکار» را فعال کرده و با{' '}
        <Link to="/wallet/charge">شارژ کیف پول</Link> بدون نیاز به کلید API از
        این بخش استفاده کنید.
      </Alert>
    );
  }

  if (!canUseAi) {
    return (
      <Alert variant="info" className="m-3 mb-0 fs--1">
        برای استفاده از تحلیل AI، ابتدا در{' '}
        <Link to="/settings/ai">تنظیمات AI</Link> یکی از حالت‌های «AI خودکار» یا
        «کلید API شخصی» را فعال کنید.
      </Alert>
    );
  }

  return null;
};

export default AiModalAccessAlerts;
